import React, { Component } from "react"
import { Redirect } from "react-router-dom"
import Button from "@material-ui/core/Button"
import { withStyles } from "@material-ui/core/styles"
import { withAuth0 } from "@auth0/auth0-react"
import * as api from "../utils/api"
import * as queryString from "query-string"

const styles = (theme) => ({
  h4: {
    margin: theme.spacing(2),
  },
})

class Login extends Component {
  constructor(props) {
    super(props)

    let urlParams = queryString.parse(this.props.location.search)

    this.state = {
      paramLogout: urlParams.logout ? urlParams.logout : false,
    }
  }

  render() {
    const { classes } = this.props

    if (!this.props.auth0.isAuthenticated) {
      return (
        <div className="container">
          <h4 className={classes.h4} style={{ textAlign: "center" }}>
            You are not logged in! Please
            <Button
              color="primary"
              size="small"
              style={{ textDecoration: "underline" }}
              onClick={() => this.props.auth0.loginWithRedirect()}
            >
              LOGIN
            </Button>
            to continue.
          </h4>
          {this.state.paramLogout && (
            <iframe
              title="logout"
              src={api.DASHBOARD_URL + "/dashboard-logout"}
              width="0"
              height="0"
            ></iframe>
          )}
        </div>
      )
    } else {
      return <div className="container">{<Redirect to="/tasks" />}</div>
    }
  }
}
export default withAuth0(withStyles(styles)(Login))
